export const moduleNames = {

  // ADMIN MODULES
  ADMIN_HOME: 'adminHome',
  ADMIN_DASHBOARD: 'adminDashboard',
  ADMIN_STATS_REPORT: 'adminStatsReport',
  ADMIN_USERS_DROPDOWN: 'adminUsersDropdown',
  ADMIN_USERS_LIST: 'adminUsersList',
  ADMIN_USERS_BALANCE: 'adminUsersBalance',
  ADMIN_RECOMMENDED_CPC: 'adminRecommendedCpc',
  ADMIN_UNAPPROVED_USERS: 'adminUsersUnapproved',
  ADMIN_UNAPPROVED_CREATIVES: 'adminUnapprovedCreatives',
  ADMIN_LOGS_DROPDOWN: 'adminLogs',
  ADMIN_LOGS_QUEUE_EMAIL: 'adminLogsQueueEmail',
  ADMIN_CAMPAIGNS: 'adminCampaigns',
  ADMIN_TOPUPS: 'adminTopUps',
  ADMIN_GROUPS: 'adminGroups',
  ADMIN_CAMPAIGNS_BIDS: 'adminCampaignsBids',
  ADMIN_CAMPAIGNS_GROUPS: 'adminCampaignsGroups',
  ADMIN_CAMPAIGNS_CREATIVES: 'adminCampaignsCreatives',
  ADMIN_BIDS: 'adminBids',
  ADMIN_LOGIN_HISTORY: 'adminLoginHistory',
  ADMIN_PROFILE: 'adminProfile',
  ADMIN_OVERVIEW_DROPDOWN: 'adminOverviewDropdown',
  ADMIN_OVERVIEW_COUNTRIES: 'adminOverviewCountries',
  ADMIN_CHANGELOG: 'adminChangelog',

  ADVERTISER_HOME: 'advertiserHome',
  ADVERTISER_CAMPAIGNS: 'advertiserCampaigns',
  ADVERTISER_TOPUPS: 'advertiserTopUps',
  ADVERTISER_LOGIN_HISTORY: 'advertiserLoginHistory',
  ADVERTISER_STATS_REPORT: 'advertiserStatsReport',
  ADVERTISER_DASHBOARD: 'advertiserDashboard',
  ADVERTISER_OPTIMIZERS: 'optimizers',
  ADVERTISER_TRACKING: 'advertiserTracking',
  ADVERTISER_PROFILE: 'advertiserProfile',
  ADVERTISER_CREATIVES: 'advertiserCreatives',

  PAYMENT_INFORMATION: 'paymentInformation',
  PROFILE: 'profile',


  //SYSTEM MODULES
  LOGOUT: 'logout',
  ADMIN_FAST_LOGIN: 'Log in as',

  //DEV MODULES
  DEV_BUILDER_DROPDOWN: 'devBuilderDropdown',
  DEV_BUILDER_MODULE: 'devModuleBuilder',
}